export const getOptionalValue = (value: any): string =>
  typeof value === "number" ? String(value) : value ? String(value) : "N/A"
